import { FeatureType } from '@/models/applications/feature-type';
import flagsmith from 'flagsmith';

export default class FlagsmithService {
    private featureEnabled: boolean = false;

    public async isFeatureEnabled(featureType: FeatureType): Promise<boolean> {
        await flagsmith.init({
            environmentID: process.env.VUE_APP_FLAGSMITH_ENVIRONMENT_API_KEY || '',
            onChange: () => {
                this.featureEnabled = flagsmith.hasFeature(FeatureType[featureType]);
            },
        });

        return this.featureEnabled;
    }
}

export const flagsmithService = new FlagsmithService();
